import { render, staticRenderFns } from "./MSelect.vue?vue&type=template&id=f85304ac&scoped=true&"
import script from "./MSelect.vue?vue&type=script&lang=ts&"
export * from "./MSelect.vue?vue&type=script&lang=ts&"
import style0 from "./MSelect.vue?vue&type=style&index=0&id=f85304ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f85304ac",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
